/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Phone_Is_Phone_Book_EnabledInputs */

const en_forms_teams_settings_phone_is_phone_book_enabled = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_Phone_Book_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book Enabled`)
};

const de_forms_teams_settings_phone_is_phone_book_enabled = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_Phone_Book_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressbuch aktiviert`)
};

/**
* | output |
* | --- |
* | "Book Enabled" |
*
* @param {Forms_Teams_Settings_Phone_Is_Phone_Book_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_phone_is_phone_book_enabled = /** @type {((inputs?: Forms_Teams_Settings_Phone_Is_Phone_Book_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Phone_Is_Phone_Book_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_phone_is_phone_book_enabled(inputs)
	return de_forms_teams_settings_phone_is_phone_book_enabled(inputs)
});